import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FileIcon from "../../../Icons/FileIcon";
import { BiDotsVerticalRounded } from "react-icons/bi";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
} from "@mui/material";

function MoreOptions() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <BiDotsVerticalRounded
        size="1.5rem"
        className="cursor-pointer"
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List sx={{ width: "200px" }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary="Download" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary="Replace" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemText primary="Delete" sx={{ color: "red" }} />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
    </div>
  );
}

function createData(id, item, file, expirationDate, status) {
  return { id, item, file, expirationDate, status };
}

const rows = [
  createData("1", "Employment Info", "Employment Info.pdf", "-", "Completed"),
  createData("2", "Employment Info", "Employment Info.pdf", "-", "Completed"),
  createData("3", "Employment Info", "Employment Info.pdf", "-", "Completed"),
];

function OfferApplicationTable() {
  return (
    <div>
      <TableContainer component={Paper} className="tableContainer">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB" }}>
            <TableRow>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                #
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                Item
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                File
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                Expiration Date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] customTableHead"
              >
                Status
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold text-[#98A2B3] text-[12px] customTableHead"
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="customTableBody">
                  {row.id}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.item}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  <div className="flex gap-2 ">
                    <FileIcon />
                    <span>{row.file}</span>
                  </div>
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.expirationDate}
                </TableCell>
                <TableCell
                  align="left"
                  className="!text-[#32D583] font-bold customTableBody"
                >
                  {row.status}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  <MoreOptions />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default OfferApplicationTable;
